"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinCardBarebones;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function SpinCardBarebones({
  domain,
  domainData,
  product,
  AddToCartButton,
  PriceBlock
}) {
  const {
    Fqdn
  } = domain;
  const tldClassNames = (0, _classnames.default)('domain-name font-weight-semibold', {
    'text-purple': false
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex modernize-spin align-items-center px-0 h-9"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-domain-info",
    className: `d-inline-flex spins-domain-info px-4`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `d-inline-flex flex-grow-1 flex-column justify-content-center`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `d-flex align-items-center pt-1`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "overflow-wrap"
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: Fqdn,
    className: `ms6 mr-2`,
    dir: "ltr"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: tldClassNames,
    "data-testid": "domain-name"
  }, /*#__PURE__*/_react.default.createElement("span", null, Fqdn)))))), product && PriceBlock && /*#__PURE__*/_react.default.createElement(PriceBlock, {
    domain: domainData,
    product: product
  })), product && AddToCartButton && /*#__PURE__*/_react.default.createElement(AddToCartButton, {
    domain: domainData,
    product: product,
    dataEid: 'add-to-cart'
  }));
}
SpinCardBarebones.propTypes = {
  domain: _propTypes.default.object.isRequired,
  product: _propTypes.default.object.isRequired,
  PriceBlock: _propTypes.default.func,
  AddToCartButton: _propTypes.default.func,
  domainData: _propTypes.default.object
};